<template>
  <div class="back">
    <div class="header">
      <img src="../png/qssyLogo.jpg" style="width: 160px;height:55px;float: left;margin-left: 13%;  padding-top: 0.8% " @click="handleBack"/>
      <!--      <p>|</p>-->
      <!--      <span style="float: left;font-size: 24px;padding-top: 2%"> | 廉洁举报平台</span>-->
      <div style="padding-top:2.8%;float: right;padding-right: 5%">
        <!--        <span class="topRightButton"><a @click="toForm">我要举报</a></span>-->
<!--        <span class="topRightButton"><a class="topRightButtonA" @click="openPhone">微信公众号举报</a></span>-->
<!--        <span class="topRightButton"> | <a class="topRightButtonA" @click="openPhone">专线电话举报</a></span>-->
        <span class="topRightButton"><a class="topRightButtonA" @click="openWx">微信公众号举报</a></span>
        <span class="topRightButton"> | <a class="topRightButtonA" @click="openPhone">专线电话举报</a></span>
        <span class="topRightButton"> | <a class="topRightButtonA" @click="openEmail">电子邮箱举报</a></span>
        <span class="topRightButton"> | <a class="topRightButtonA" @click="openMail">信函举报</a></span>
        <span class="topRightButton">| <a class="topRightButtonA" @click="toProblem">常见问题</a></span>
      </div>
    </div>
    <div style="width: 72.6%;margin-left: 13.5%;text-align: left;">
      <h2 >填写举报内容</h2>
      <div style="margin-left: 5.2%">
      <h4>举报人基本信息</h4>
      <div style="border: 1px solid black;padding: 20px;border-radius: 10px;max-height:350px;" >
        <el-radio-group v-model="type">
          <el-radio label='1'>实名举报</el-radio>
          <el-radio label='2'>匿名举报</el-radio>
        </el-radio-group>
        <el-form  ref="needForm" :model="form"  label-width="50px" label-position="left"
                  :rules="rules" v-show="type=='1'"  inline>
          <br>
          <el-form-item label="姓名" prop="personName">
            <el-input
              type="text"
              placeholder="姓名"
              @blur="onInputBlur"
              class="ptTxtInput"
              style="width: 200px"
              size="mini"
              v-model="form.personName">
            </el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="email" style="margin-left:6%">
            <el-input
              type="text"
              placeholder="邮箱"
              @blur="onInputBlur"
              class="ptTxtInput"
              style="width: 200px"
              size="mini"
              v-model="form.email">
            </el-input>
          </el-form-item>
          <el-form-item label="电话" prop="phone" style="margin-left: 6%">
            <el-input
              type="text"
              placeholder="电话"
              @blur="onInputBlur"
              class="ptTxtInput"
              style="width: 200px"
              size="mini"
              v-model="form.phone">
            </el-input>
          </el-form-item>
          <el-form-item label="其他联系方式" prop="otherSnsType"  label-width="100px" style="margin-top: -0.6%">
            <el-select v-model="form.otherSnsType" placeholder="请选择"  size="mini" style="width: 100px;">
              <el-option label="微信" value="1"></el-option>
              <el-option label="QQ" value="2"></el-option>
              <el-option label="其他" value="3"></el-option>
            </el-select>
            <el-input
              type="text"
              placeholder="请输入内容"
              @blur="onInputBlur"
              size="mini"
              style="width: 250px;margin-left: 10px"
              class="ptTxtInput"
              v-model="form.otherSns">
            </el-input>
          </el-form-item>
<!--          <el-form-item>-->
<!--            <el-input-->
<!--              type="text"-->
<!--              placeholder="请输入内容"-->
<!--              @blur="onInputBlur"-->
<!--              size="mini"-->
<!--              style="width: 250px;margin-top: -2%"-->
<!--              class="ptTxtInput"-->
<!--              v-model="form.otherSns">-->
<!--            </el-input>-->
<!--          </el-form-item>-->
        </el-form>
        <el-form  ref="noNeedForm" :model="form2" label-width="50px"
                  label-position="left" v-show="type=='2'" inline>
          <br>
          <el-form-item label="姓名" prop="personName">
            <el-input
              type="text"
              placeholder="姓名"
              @blur="onInputBlur"
              class="ptTxtInput"
              style="width: 200px"
              size="mini"
              disabled
              v-model="form2.personName">
            </el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="email"  style="margin-left: 6%">
            <el-input
              type="text"
              placeholder="邮箱"
              @blur="onInputBlur"
              class="ptTxtInput"
              style="width: 200px"
              disabled
              size="mini"
              v-model="form2.email">
            </el-input>
          </el-form-item>
          <el-form-item label="电话" prop="phone"  style="margin-left: 6%">
            <el-input
              type="text"
              placeholder="电话"
              @blur="onInputBlur"
              class="ptTxtInput"
              style="width: 200px"
              disabled
              size="mini"
              v-model="form2.phone">
            </el-input>
          </el-form-item>
          <el-form-item label="其他联系方式" prop="otherSnsType" label-width="100px"  style="margin-top: -0.6%">
            <el-select v-model="form2.otherSnsType" placeholder="请选择"
                       disabled
                       size="mini" style="width: 100px">
              <el-option label="微信" value="1"></el-option>
              <el-option label="QQ" value="2"></el-option>
            </el-select>
            <el-input
              type="text"
              placeholder="请输入内容"
              @blur="onInputBlur"
              class="ptTxtInput"
              size="mini"
              disabled
              style="width: 250px;margin-left: 10px"
              v-model="form2.otherSns">
            </el-input>
          </el-form-item>
<!--          <el-form-item>-->
<!--            <el-input-->
<!--              type="text"-->
<!--              placeholder="请输入内容"-->
<!--              @blur="onInputBlur"-->
<!--              class="ptTxtInput"-->
<!--              size="mini"-->
<!--              style="width: 250px;margin-top: -2%"-->
<!--              v-model="form2.otherSns">-->
<!--            </el-input>-->
<!--          </el-form-item>-->
        </el-form>
      </div>
        <div style="margin-top: 2%">
<!--          <h4>被举报人基本信息</h4>-->
          <span style="font-size: 16px"><b>被举报人基本信息</b></span>
          <el-button style="margin-bottom: 5px;margin-left: 1%" @click="handleAddNew" icon="el-icon-plus" size="small"> 新增被举报人</el-button>
        </div>
      <div style="border: 1px solid black;padding: 20px;border-radius: 10px;max-height:220px;overflow:auto;margin-top: 1%" >
<!--        <div style="margin-top: 1%">-->

<!--        </div>-->
        <div v-for="(item,index) in entry">
          <el-form :model="item"   label-width="80px" label-position="left" inline>
            <el-form-item label="被举报人" prop="tarName"
                          :rules="[
                            { required: true, message: '请输入被举报人', trigger: 'blur' }
                          ]" >
              <el-input
                style="width: 150px"
                size="mini"
                type="text"
                placeholder="被举报人"
                @blur="onInputBlur"
                v-model="item.tarName">
              </el-input>
<!--              <el-button v-if="index>0" @click="deleteEntry(index)">-->
<!--                删除被举报人-->
<!--              </el-button>-->
            </el-form-item>
            <el-form-item label="被举报人所属公司" prop="tarCompany" label-width="125px" style="margin-left:0.5%">
              <el-input
                type="text"
                style="width: 250px"
                size="mini"
                placeholder="被举报人所属公司"
                @blur="onInputBlur"
                v-model="item.tarCompany">
              </el-input>
            </el-form-item>
            <el-form-item label="被举报人职务" prop="tarPosition" label-width="100px"  style="margin-left:0.5%">
              <el-input
                type="text"
                style="width: 190px"
                size="mini"
                placeholder="被举报人职务"
                @blur="onInputBlur"
                v-model="item.tarPosition">
              </el-input>
            </el-form-item>
            <el-button v-if="index>0" @click="deleteEntry(index)" size="mini" circle icon="el-icon-delete" type="danger" style="margin-top: 0.5%" plain>

            </el-button>
          </el-form>
<!--          <el-divider ></el-divider>-->
        </div>
      </div>
      <h4>举报事项</h4>
      <div style="border: 1px solid black;padding: 20px;border-radius: 10px;max-height:520px;overflow:auto" >
        <el-form ref="matter" :model="matter"  :rules="rules">
          <el-form-item label="举报主题" prop="title">

            <el-input
              type="text"
              style="width: 300px"
              placeholder="举报主题"
              size="mini"
              @blur="onInputBlur"
              v-model="matter.title">
            </el-input>
          </el-form-item>
          <el-form-item label="举报内容" prop="content">
            <el-input type="textarea" v-model="matter.content"  @blur="onInputBlur" style="width: 850px;" rows="15"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <el-upload
        class="upload-demo"
        ref="upload"
        :action="uploadUrl"
        accept=".pdf,.png,.jpg,.jpeg,.doc,.docx,.xls,.xlsx,.zip,.7z,.ppt"
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :file-list="fileList"
        style="width:820px"
        multiple
        :auto-upload="false">
        <el-button slot="trigger" size="small" type="primary" style="margin-top: 20px;font-size: 14px">添加举报附件</el-button>
        <span style="font-size: 12px;color: grey;">（ 最多上传20个文件，每个文件大小不超过50M，可上传格式为：jpg、jpeg、png、doc、docx、xls、xlsx、ppt、rar、zip、pdf ）</span>
  <!--      <a href="/举报信息表格模版.docx" > 下载模版 </a>-->
  <!--      <el-link href="举报信息表格模版.docx">-->
<!--        <el-link target="_blank" href="/static/举报信息表格模版.docx" :underline="false" style="margin-left:10px">-->
<!--          <el-button size="small">模板下载</el-button>-->
<!--        </el-link>-->
  <!--        <el-button size="small"  style="margin-top: 5px" @click="handleDownLoad">下载模版</el-button>-->
  <!--      </el-link>-->
  <!--      <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>-->
<!--        <div slot="tip" class="el-upload__tip">最多上传20个文件，每个文件大小不超过50M <br>可上传格式为:jpg, jpeg, png, doc, docx, xls, xlsx, ppt, rar, zip, 7z, pdf;</div>-->
      </el-upload>
      <el-button style="margin-top: 20px;float: left;margin-left: 37%;width: 10%" @click="handleBack" size="big" >返回首页</el-button>
      <el-button style="margin-top: 20px;float: left;margin-left: 5%;width: 10%" @click="handleSubmit" size="big" type="primary"> 提交</el-button>
  <!--    <el-button style="text-align: center"  size="small"> 提交</el-button>-->
        <br><br><br>
    </div>
    </div>
    <div style="height: 30px;margin-top: 30px;width: 100%">

    </div>
    <wx-code v-if="wxCodeOpen" :wxCodeOpen="wxCodeOpen" @refreshDataList="closeWx"></wx-code>
  </div>
</template>

<script>
import wxCode from './wxCode';
const axios = require('axios');
import request from '@/api/request'
export default {
  name: "form",
  data(){
    return{
      wxCodeOpen:false,
      type:"1",
      form:{
        personName:"",
        email:"",
        phone:"",
        otherSnsType:"",
        otherSns:"",
      },
      form2:{
        personName:"",
        email:"",
        phone:"",
        otherSnsType:"",
        otherSns:""
      },
      upload: {
        isUploading: false,
      },
      matter:{
        title:"",
        content:""
      },
      entry:[
        {
          tarName:"",
          tarCompany:"",
          tarPosition:"",
        },
      ],
      fileList:[

      ],
      uploadUrl:"",
      rules: {
        personName: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        // email: [
        //   { required: true, message: '请输入邮箱', trigger: 'blur' },
        // ],
        phone: [
          { required: true, message: '请输入电话', trigger: 'blur' },
        ],
        title: [
          { required: true, message: '请输入举报主题', trigger: 'blur' },
        ],
        content: [
          { required: true, message: '请输入举报内容', trigger: 'blur' },
        ],
      }
    }
  },
  components:{wxCode},
  created() {
    let formStr = localStorage.getItem("form");
    // console.log(formStr);
    // console.log(formStr!=null);
    // console.log(formStr!="null");
    if(formStr!=null && formStr!="null"){
      let form=JSON.parse(formStr);
      this.form=form;
    }
    let formStr2 = localStorage.getItem("form2");
    if(formStr2!=null && formStr2!="null"){
      let form2=JSON.parse(formStr2);
      this.form2=form2;
    }
    let entryStr = localStorage.getItem("entry");
    // console.log(entryStr);
    if(entryStr!=null && entryStr!="null"){
      let entry=JSON.parse(entryStr);
      this.entry=entry;
    }
    let matterStr = localStorage.getItem("matter");
    if(matterStr!=null && matterStr!="null"){
      let matter=JSON.parse(matterStr);
      this.matter=matter;
    }
    // this.submitForm();
  },
  methods:{
    toProblem(){
      this.$router.push({ name:'WebProblem'})
    },
    toForm(){
      this.$router.push({ name:'WebForm'})
    },
    openTss() {
      let msg='登录集团官网www.tssgroup.com.cn，点击“廉洁青山”进入“青山实业廉洁举报平台”；'
      this.$alert(msg, '官网平台', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        callback: action => {
        }
      });
    },
    openPhone() {
      let msg='&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;座机：0577-86887787<br>' +
        '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;手机：13336919977<br>'+
        '&nbsp;&nbsp;&nbsp;（&nbsp;夏令：8:30-17:30； 冬令：8:30-17:00&nbsp;）'
      this.$alert(msg, '专线电话', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        callback: action => {
        }
      });
    },
    openEmail() {
      let msg='&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;jubao@tssgroup.com.cn';
      this.$alert(msg, '举报受理邮箱', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        callback: action => {
        }
      });
    },
    openMail() {
      let msg='&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;方式一：投递信函至公司举报信箱；<br>'+
        '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;方式二：邮寄信函至浙江省温州市龙湾区龙祥路2666号青山实业董事局监察安全委员会廉洁监察部（收）。';
      this.$alert(msg, '信函举报', {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        callback: action => {
        }
      });
    },
    //失去焦点事件
    onInputBlur(){
      let form= JSON.stringify(this.form);
      localStorage.setItem("form",form);
      let form2= JSON.stringify(this.form2);
      localStorage.setItem("form2",form2);
      let entry= JSON.stringify(this.entry);
      localStorage.setItem("entry",entry);
      let matter= JSON.stringify(this.matter);
      localStorage.setItem("matter",matter);
      // console.log(111111);
    },
    deleteEntry(index){
      this.entry.splice(index, 1);
    },
    handleDownLoad(){
      window.location.href = "举报信息表格模版.docx";
      // window.location.href = "/举报信息表格模版.docx";
    },
    handleBack(){
      this.$router.push({ name:'WebIndex'})
    },
    handleSubmit(){
      if(this.type=="1"){
        this.$refs['needForm'].validate((valid) => {
          if (valid) {
            this.submitForm();
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }else if(this.type=="2"){
        this.submitForm();
      }
    },

    //表单提交
    submitForm(){
      console.log(this.entry)
      let error="";
      this.$refs['matter'].validate((valid) => {
        if (valid) {
          for (let i = 0; i < this.entry.length; i++) {
            if (this.entry[i].tarName == "") {
              let msg = "第" + (i + 1) + "条,被举报人为空,不能提交";
              error = error + msg + "<br/>"
              // this.$message.error('第'+(i+1)+'条,被举报人为空,不能提交');
              // return;
            }
            // if(this.entry[i].title==""){
            //   let msg='第'+(i+1)+'条,举报主题为空,不能提交';
            //   error=error+msg+"<br/>"
            //   // this.$message.error('第'+(i+1)+'条,举报主题为空,不能提交');
            //   // return;
            // }
            // if(this.entry[i].content==""){
            //   let msg='第'+(i+1)+'条,举报内容为空,不能提交';
            //   error=error+msg+"<br/>"
            //   // this.$message.error('第'+(i+1)+'条,举报内容为空,不能提交');
            //   // return;
            // }
          }
          if (error != "") {
            this.$message({
              dangerouslyUseHTMLString: true,
              message: error,
              type: "error",
              duration: 10000
            });
          } else {
            let httpURL = `/disciplice/add`; //目标地址后接的详细地址
            let data = {}
            if (this.type == "1") {
              data = this.form;
            } else if (this.type == "2") {
              data = this.form2;
            }
            data.type = this.type;
            data.entry = this.entry;
            data.matter=this.matter;
            data.channel="平台举报";
            let that = this;
            request.post(httpURL, data).then(function (res) {
              // console.log(res);
              if (res.code == "0") {
                that.uploadUrl="/disciplice/upload/"+res.data.id;
                that.form={
                  personName:"",
                    email:"",
                    phone:"",
                    otherSnsType:"",
                    otherSns:"",
                };
                that.form2={
                  personName:"",
                    email:"",
                    phone:"",
                    otherSnsType:"",
                    otherSns:""
                };
                that.matter={
                  title:"",
                    content:""
                };
                that.entry=[
                  {
                    tarName:"",
                    tarCompany:"",
                    tarPosition:"",
                  },
                ];
                that.onInputBlur();
                // console.log(that.uploadUrl);
                // localStorage.setItem("form",null);
                // localStorage.setItem("form2",null);
                // localStorage.setItem("entry",null);
                // localStorage.setItem("matter",null);
                that.submitUpload();
                let msg = "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本次举报已成功提交，感谢您的信任！" +
                  "<br><b style='font-size: 18px;color:#409EFF;'><p style='text-align: center;line-height: 50px'>举报凭证号：" + res.data.number+"</p></b>" +
                  "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;该凭证号是核实您举报身份、咨询举报进展、领取举报奖励的有效凭证，请妥善保管。";
                that.$alert(msg, '提交成功', {
                  dangerouslyUseHTMLString: true,
                  confirmButtonText: '确定',
                  callback: action => {
                    that.$router.push({name: 'WebIndex'})
                    // this.$message({
                    //   type: 'info',
                    //   message: `action: ${ action }`
                    // });
                  }
                });
              } else {
                that.$message.error(res.msg);
              }
            });
          }
        }})
    },
    handleAddNew(){
      let param={
        tarName:"",
        tarCompany:"",
        tarPosition:"",
        // title:"",
        // content:""
      };
      this.entry.push(param)
    },
    submitUpload() {
      const that = this;
      setTimeout(function() {
        that.$refs.upload.submit();
      }, 400)
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(row) {
      let url=URL.createObjectURL(row.raw);
      window.open(url);
      // console.log(file);
    },
    openWx(){
      this.wxCodeOpen=true;
    },
    closeWx(){
      this.wxCodeOpen=false;
    }
  }
}
</script>

<style scoped>
.back{    /* div的CSS样式 */
  position : absolute;
  top:0;
  left: 0;
  width : 100%;
  height :100%;
  /*background: url("static/png/back.jpg");*/
  /*background-image: url("../png/back.jpg");*/
  /*background-size:100% 100%;*/
}
.header{
  width: 100%;
  height: 10%;
  background: white;
  border-bottom: 1px solid gainsboro;
}
.ptTxtInput{
  width:140px;
}
.topRightButton{
  font-size: 14px;
  cursor: pointer;
  color: grey;
  /*padding-top: 20px*/

}
.topRightButtonA:hover{
  color: #4169E1
  /*padding-top: 20px*/

}
</style>



// WEBPACK FOOTER //
// src/pages/web/form.vue